import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProjectEnvironment, ProjectIs, ProjectProfile } from '../../../models/projects.model';
import {
  AccessRulesState,
  ConfigFeatures,
  defaultConfig,
  ProjectInfo,
} from '../models/access-rules.model';

@Injectable({
  providedIn: 'root',
})
export class AccessRulesStateService {
  private stateSubject = new BehaviorSubject<AccessRulesState>({
    profile: ProjectProfile.ACME,
    environment: ProjectEnvironment.DEV,
    projectName: '',
    logoBase64: '',
    compactLogoBase64: '',
    faviconUrl: '',
    supportAbbreviation: '',
    features: defaultConfig,
    projectInfo: {
      name: '',
      abbreviation: ProjectIs.ACME,
      phone: '',
      fax: '',
      email: '',
      address_line_one: '',
      address_line_two: '',
      url: '',
    },
  });

  updateState(state: AccessRulesState): void {
    this.stateSubject.next({
      ...state,
    });
  }

  getState(): AccessRulesState {
    return this.stateSubject.value;
  }

  getProfile(): ProjectProfile {
    return this.stateSubject.value.profile;
  }

  getEnvironment(): ProjectEnvironment {
    return this.stateSubject.value.environment;
  }

  getProjectName(): string {
    return this.stateSubject.value.projectName;
  }

  getLogoBase64(): string {
    return this.stateSubject.value.logoBase64;
  }

  getCompactLogoBase64(): string {
    return this.stateSubject.value.compactLogoBase64;
  }

  getFaviconUrl(): string {
    return this.stateSubject.value.faviconUrl;
  }

  getSupportAbbreviation(): string {
    return this.stateSubject.value.supportAbbreviation;
  }

  getFeatures(): ConfigFeatures {
    return this.stateSubject.value.features;
  }

  getProjectInfo(): ProjectInfo {
    return this.stateSubject.value.projectInfo;
  }

  isProfileMaster(): boolean {
    return this.stateSubject.value.profile === ProjectProfile.UTMC;
  }
}
